<div class="login-page">

  <!-- Painel esquerdo - Branding -->
  <div class="login-branding">
    <div class="branding-content">
      <img src="assets/icon-clinixcore-light.svg" alt="ClinixCore" class="brand-icon-hero">
      <h1 class="brand-title">ClinixCore</h1>
      <p class="brand-subtitle">O núcleo da sua prática clínica</p>
      <p class="brand-description">Recupere o acesso à sua conta de forma rápida e segura</p>
      <div class="brand-features">
        <div class="feature-item"><i class="bi bi-shield-check"></i> Processo seguro</div>
        <div class="feature-item"><i class="bi bi-clock-history"></i> Link válido por 1 hora</div>
        <div class="feature-item"><i class="bi bi-envelope-check"></i> Confirmação por email</div>
      </div>
    </div>
  </div>

  <!-- Painel direito - Formulário -->
  <div class="login-form-panel">
    <div class="login-card">

      <!-- Logo Mobile -->
      <div class="text-center mb-4 d-md-none">
        <img src="assets/logo-clinixcore.svg" alt="ClinixCore" style="height: 45px;">
      </div>

      <!-- Título compacto -->
      <div class="text-center mb-3">
        <h2 class="h5 mb-2 fw-semibold text-dark">
          <i class="bi bi-key text-primary me-2"></i>
          Recuperar senha
        </h2>
        <p class="text-muted small mb-0" *ngIf="!emailSent">
          Digite seu email para receber o link de recuperação
        </p>
      </div>

      <!-- Espaçador para alinhamento -->
      <div class="mb-5"></div>

      <!-- Mensagem de sucesso -->
      <div class="alert alert-success d-flex align-items-start gap-2 mb-3" *ngIf="emailSent && successMessage">
        <i class="bi bi-check-circle-fill fs-5 flex-shrink-0"></i>
        <div>
          <strong>Email enviado com sucesso!</strong>
          <p class="mb-0 mt-1">{{ successMessage }}</p>
          <p class="mb-0 mt-2 small">
            <i class="bi bi-info-circle"></i>
            Não se esqueça de verificar sua caixa de spam.
          </p>
        </div>
      </div>

      <!-- Mensagem de erro -->
      <div class="alert alert-danger d-flex align-items-center gap-2 mb-3" *ngIf="errorMessage">
        <i class="bi bi-exclamation-triangle-fill flex-shrink-0"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <!-- Formulário -->
      <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()" *ngIf="!emailSent">
        <div class="mb-4">
          <label class="form-label">Email</label>
          <input type="email" class="form-control" formControlName="email"
                 placeholder="seu@email.com"
                 [class.is-invalid]="f['email'].invalid && f['email'].touched">
          <div class="invalid-feedback">
            <span *ngIf="f['email'].hasError('required')">Email obrigatório</span>
            <span *ngIf="f['email'].hasError('email')">Email inválido</span>
          </div>
        </div>

        <button type="submit" class="btn btn-primary w-100 mb-3" [disabled]="loading">
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
          {{ loading ? 'Enviando...' : 'Enviar link de recuperação' }}
        </button>
      </form>

      <!-- Botão voltar (sempre visível) -->
      <button type="button" class="btn btn-outline-secondary w-100" (click)="backToLogin()">
        <i class="bi bi-arrow-left me-2"></i>
        Voltar para o login
      </button>

      <!-- Link de ajuda -->
      <div class="text-center mt-4">
        <p class="text-muted small mb-0">
          Precisa de ajuda? Entre em contato com nosso suporte.
        </p>
      </div>

    </div>
  </div>

</div>
